// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-who-we-are----team-module---container---1nqLv","title":"src-components-who-we-are----team-module---title---2XXWd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/who-we-are/team.module.scss
// module id = 370
// module chunks = 36434998819415 125193764933041